import client from '../httpClient';

const allocationSettingGetApi = (params) => {
  return client.get('/allocation-settings/', { params });
};

export default allocationSettingGetApi;
